/**
 * Signed-link routes — MyDossier opened from a reminder email, no login.
 * The 24h link token in the path IS the auth; the ApiClient simply has no
 * bearer to attach (getToken → null) and these routes never require one.
 */

import type {
  ClassificationActionRequest,
  Document,
  Dossier,
  PresignedUpload,
  PresignedUploadRequest,
  Uuid,
} from "@re-platform/types";

import type { ApiClient } from "../client";

export const linkService = {
  resolve(client: ApiClient, token: string) {
    return client.request<Dossier>(`/document/dossiers/by-link/${token}`);
  },

  presignedUrl(client: ApiClient, token: string, body: PresignedUploadRequest) {
    return client.request<PresignedUpload>(
      `/document/dossiers/by-link/${token}/presigned-url`,
      { method: "POST", body },
    );
  },

  listDocuments(
    client: ApiClient,
    token: string,
    params?: { classification_status?: string; limit?: number },
  ) {
    return client.request<Document[]>(
      `/document/dossiers/by-link/${token}/documents`,
      {
        query: params,
      },
    );
  },

  classify(
    client: ApiClient,
    token: string,
    documentId: Uuid,
    body: ClassificationActionRequest,
  ) {
    return client.request<Document>(
      `/document/dossiers/by-link/${token}/documents/${documentId}/classification`,
      { method: "POST", body },
    );
  },
};
